<p class="flex items-center justify-between rounded-xl border border-primary-100 bg-primary-50 p-3">
  <span class="prose-text-sm font-medium text-primary-900" translate>msg.unexpected_error</span>
  <button
    app-icon-button
    name="x"
    (click)="closePopup()"
    type="button"
    class="bg-white"
    size="sm"></button>
</p>
